<div class="preview-field">
    <div class="preview-field__content-container preview-field__content-container--label">
        <ng-content select="preview-field_label"></ng-content>
    </div>
    <div class="preview-field__content-container">
        <ng-content select="preview-field_val"></ng-content>
    </div>
</div>
